module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-notification pm-notification"
  }, [_c('div', {
    staticClass: "notification",
    class: {
      success: (_vm.notification.style == 'success'), alert: (_vm.notification.style == 'alert'), warning: (_vm.notification.style == 'warning')
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Close alert",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeNotification()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.notification.title))])]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.notification.subtitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e1b6f4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Notification.vue
// module id = 2262
// module chunks = 1